export const INCLUB_APP_STORE_URL = 'https://apps.apple.com/pe/app/inclub-world/id6754095554';

export const INCLUB_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.inclub.app';

export const INCLUB_APP_STORE_BADGE_URL =
	'https://s3.us-east-2.amazonaws.com/backoffice.documents/bo-imagenes/27e9add9-930d-4de8-9e5d-a004bfe1c614-app&store&es.svg';

export const INCLUB_PLAY_STORE_BADGE_URL =
	'https://s3.us-east-2.amazonaws.com/backoffice.documents/bo-imagenes/5f1890dd-b757-428f-ae79-5bbe4a41d799-google&play&es.png';

export const INCLUB_BOT_IMAGE_URL =
	'https://s3.us-east-2.amazonaws.com/backoffice.documents/bo-imagenes/c36060b3-fb9f-4c1d-83c9-5c1b040d606e-bot&inclub.png';
